import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CameraComponent } from '../../components/camera/camera.component';
import { MediaSource } from '../../schema/enums/media-source';
import { ICustomFile } from '../../schema/interfaces/ICustomFile';

@Injectable({
  providedIn: 'root'
})
export class CameraProviderService {
  constructor(private modalCtrl: ModalController) {}

  /**
   * Shows the camera component view to select and preview a picture/video.
   */
  showCamera(mediaSource: MediaSource): Promise<ICustomFile> {
    const componentProps = { mediaSource: mediaSource };
    const options = { component: CameraComponent, componentProps };
    return this.modalCtrl.create(options).then(modal => modal.present().then(() => modal.onDidDismiss().then(result => result.data)));
  }
}
